import React from 'react';
import PropTypes from 'prop-types';
import { get, debounce, isEmpty, trim } from 'lodash';

export default class ASQTextArea extends React.PureComponent {
  static propTypes = {
    asq: PropTypes.object.isRequired,
    responseType: PropTypes.object.isRequired,
    answer: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    disabled: false,
  }

  constructor(props) {
    super(props);
    this.state = { value: props.answer ? props.answer.textAnswer : '' };
  }

  delayedOnChange = debounce(value => {
    const answerId = get(this.props.answer, 'id', null);
    if (isEmpty(trim(value))) {
      if (answerId) this.props.onDelete(answerId, {
        asqResponseTypeId: this.props.responseType.id,
        id: answerId }
      );
    } else {
      this.props.onChange(answerId, {
        asqResponseTypeId: this.props.responseType.id,
        textAnswer: value }
      );
    }
  }, 500)

  onChange = e => {
    this.setState({ value: e.target.value });
    this.delayedOnChange(e.target.value);
  }

  render() {
    const { responseType, disabled } = this.props;
    return (
      <div className='o-textarea-answer u-padding-bottom--small'>
        <label>
          {responseType.label}
          <textarea rows='6' value={this.state.value} onChange={this.onChange} disabled={disabled}/>
        </label>
      </div>
    );
  }
}
